import axios from 'axios'
import {FETCH_PATH_REQUEST,FETCH_PATH_SUCCESS,FETCH_PATH_FAILURE} from './fetchTypes'

export const fetchPathRequest = () => {
    return {
        type: FETCH_PATH_REQUEST
    }
}

export const fetchPathSuccess = paths => {
    return {
        type: FETCH_PATH_SUCCESS,
        payload: paths
    }
}

export const fetchPathFailure = error => {
    return {
        type: FETCH_PATH_FAILURE,
        payload: error
    }
}

export const fetchPath = (object) => {
    
    return (dispatch) => {
        dispatch(fetchPathRequest())
        axios.get(object.url,{headers: window.tp_headers})
        .then(response => {            
            const paths = response.data

            //RIMOZIONE PERCORSI CON PIU' VOLI AEREI
            if(window.configFile.serviceOnScreen.prepost_elaboration && paths.plan && paths.plan.itineraries){
                let regex = /AIRPLANE/gi     
                for (let i = 0; i < paths.plan.itineraries.length; i++) {
                    var legs=JSON.stringify(paths.plan.itineraries[i])
                    if((legs.match(regex) || []).length>1) paths.plan.itineraries.splice(i, 1)
                }
            }
            
            //ORDINAMENTO
            switch (object.ordine) {
                case 0:
                    break;
                case 1:
                    paths.plan.itineraries.sort((a,b) => (a.startTime > b.startTime) ? 1 : ((b.startTime > a.startTime) ? -1 : 0))
                    break;
                case 2:
                    paths.plan.itineraries.sort((a,b) => (a.duration > b.duration) ? 1 : ((b.duration > a.duration) ? -1 : 0))
                    break;
                case 3:
                    paths.plan.itineraries.sort((a,b) => (a.walkTime > b.walkTime) ? 1 : ((b.walkTime > a.walkTime) ? -1 : 0))
                    break;
                case 4:
                    paths.plan.itineraries.sort((a,b) => (a.legs.length > b.legs.length) ? 1 : ((b.legs.length > a.legs.length) ? -1 : 0))
                    break;                    
                default:
                    break;
            }
             
            
            dispatch(fetchPathSuccess(paths))
        })
        .catch( error => {
            const errorMsg = error.message
            dispatch(fetchPathFailure(errorMsg))
        })
    }
}